import { $t } from '@/i18n';
import { computed } from '@vue/composition-api';
import store from '@/store';
export const SIDEBAR_IDENTITY = $t('k_4578bc06');
/**
 * Whether the current deploy environment allows showing the "Powered by 无极" identity.
 * Only considers environment-level constraints (not user preference).
 */
export function useCanDeployIdentity() {
    return computed(() => {
        const { open, openDeployType, externalDeploy } = window?.GLOBAL_INFO || {};
        // 外部商业化环境
        if (externalDeploy)
            return false;
        // 当前在内网环境下
        if (!open)
            return true;
        // 在open版中，但是是在内网环境下
        if (open && openDeployType === 'designer')
            return true;
        // 外网环境统一不渲染
        return false;
    });
}
/**
 * Whether to render the "Powered by 无极" identity at runtime.
 * Combines the environment constraint with the user-level toggle
 * (project.uiInfo.navlink.navConfig.showPoweredBy, default true).
 */
export function useRenderIdentity() {
    const canDeploy = useCanDeployIdentity();
    return computed(() => {
        if (!canDeploy.value)
            return false;
        const state = store?.state;
        // In runtime (deployed app) the project lives at `runtime.project`,
        // while in the workbench it lives at `project.projectInfo`.
        const project = state?.layout?.mode === 'runtime'
            ? state?.runtime?.project
            : state?.project?.projectInfo;
        const navConfig = project?.uiInfo?.navlink?.navConfig;
        // 未配置字段时保持原有行为（显示）
        if (!navConfig || navConfig.showPoweredBy === undefined)
            return true;
        return !!navConfig.showPoweredBy;
    });
}
